<form [formGroup]="phoneTypeFormGroup">
	<mat-form-field
		aria-placeholder="as"
		appearance="outline"
		class="column"
		[subscriptSizing]="flagForDisplayErrorMessage ? 'fixed' : 'dynamic'"
	>
		<div class="phone-number-container">
			<ngx-flag-picker
				[selectedCountryCode]="selectedCountryCode"
				[countryCodes]="countryCodes"
				[isDisabled]="isDisabled"
				(changedCountryCode)="changeSelectedCountryCode($event)"
			>
			</ngx-flag-picker>

			<div class="phone-number-code" [ngClass]="{ 'disabled-text-color': isDisabled }">
				{{ phoneCode }}
			</div>

			<input
				matInput
				formControlName="phone"
				[placeholder]="mobileNumberPlaceholder + (optional ? ' (' + optionalPlaceholder + ')' : '')"
				maxlength="20"
				[ngModel]="this.phoneNumber"
				(ngModelChange)="onPhoneNumberChange($event)"
				autocomplete="tel-national"
				data-automation-id="phone-number-input"
				(blur)="onBlurClick()"
			/>
		</div>
		@if (phoneTypeFormGroup.controls['phone'].invalid && phoneTypeFormGroup.controls['phone'].value) {
			<mat-error i18n="@@userSearchBar-invalidMobileNumber" data-automation-id="phone-number-error"
				>Please enter a valid mobile number</mat-error
			>
		}
		@if (
			flagForDisplayErrorMessage &&
			phoneTypeFormGroup.get('phone')?.hasError('required') &&
			(phoneTypeFormGroup.controls['phone'].touched || phoneTypeFormGroup.controls['phone'].dirty)
		) {
			<mat-error i18n="@@addEditContact-emailOrMobileRequired" data-automation-id="phone-number-or-condition-error"
				>Email or Mobile number required to enable notifications</mat-error
			>
		}
	</mat-form-field>
</form>
